import { Alert, Text } from '@change/ds-core-ui';
import { cn } from '@change/ds-utils';

import { translationKey } from '@change-corgi/core/i18n';
import { TypedTranslate } from '@change-corgi/core/react/i18n';
import { DesignSystemLegacy } from '@change-corgi/design-system-legacy/core';
import { sunriseTheme } from '@change-corgi/design-system-legacy/theme';

import { StepActions } from 'src/app/pages/startAPetitionV2/shared/components';
import { ImageCropperUploaderSunrise } from 'src/app/shared/components/imageUpload';
import { useIsMobile } from 'src/app/shared/hooks/userAgent';

import { useUploaderCropperForm } from './hooks/useUploaderCropperForm';

export const UploaderCropperForm = () => {
	const { data, actions } = useUploaderCropperForm();
	const isMobile = useIsMobile();

	return (
		<>
			<DesignSystemLegacy theme={sunriseTheme}>
				<div
					className={cn([
						// These classes are used to hide the "drop target" area (dashed box) on mobile/tablet devices
						isMobile && !data.image
							? '[&_#sap-media-view]:mb-0! [&_#sap-media-view]:w-full! [&_#sap-media-view_label]:w-full! [&>div]:aspect-[unset]! [&>div>div]:border-0! [&>div>div>div>div:first-child]:hidden!'
							: '[&_#sap-media-view]:mb-0! md:[&_#sap-media-view]:mb-16!',
					])}
				>
					<ImageCropperUploaderSunrise
						uploader={data.uploader}
						image={data.image}
						onButtonClick={actions.handleUploadClick}
						onImageChange={actions.handleImageChange}
						onImageCrop={actions.handleImageCrop}
						onCancelClick={actions.handleCancelUpload}
					/>
					{data.imageError && (
						<Alert type="inline" variant="warning" className="mt-4">
							<Text as="p" variant="body">
								<TypedTranslate value={data.imageError} />
							</Text>
						</Alert>
					)}
					{data.uploadError && (
						<Alert type="inline" variant="error" className="mt-4">
							<Text as="p" variant="body">
								<TypedTranslate value={data.uploadError} />
							</Text>
						</Alert>
					)}
				</div>
			</DesignSystemLegacy>
			<StepActions
				type="navigation"
				onPrimaryAction={actions.submit}
				onSecondaryAction={actions.back}
				submitting={data.isUploading}
				submittingLabel={translationKey('corgi.start_a_petition.media.step_actions.button.uploading_label')}
			/>
		</>
	);
};
